import getSharingLink from './getSharingLink';
export default function getSharingData(linkId) {
    var sharingLink = getSharingLink(linkId);
    return {
        id: sharingLink.linkId,
        name: sharingLink.fileName,
        supportsDownsell: false,
        currentPermissionLevel: sharingLink.permissionLevel,
        sharingInfo: sharingLink.sharingInfo,
    };
}
//# sourceMappingURL=getSharingData.js.map